import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import HeaderBottom from '../../components/HomePage/HeaderBottom';

const WorkStepReal = () => {
    const [stepwork, setWork] = useState([]);

    useEffect(() => {
        fetch(`https://ai-automation-audit-01-e0855711738d.herokuapp.com/worksec-real`)
            .then((res) => res.json())
            .then((info) => setWork(info));
    }, []);

    const handleWorkSection = (event) => {
        event.preventDefault();
        const stepNumber = event.target.stepNumber.value;
        const stepTitle = event.target.stepTitle.value;
        const stepDetails = event.target.stepDetails.value;

        const workSection = { stepNumber, stepTitle, stepDetails };

        const url = `https://ai-automation-audit-01-e0855711738d.herokuapp.com/add-worksec`;
        fetch(url, {
            method: "POST",
            headers: { "content-type": "application/json" },
            body: JSON.stringify(workSection),
        })
            .then((res) => res.json())
            .then(() => {
                alert('Work Step is Updated');
            });
    };

    return (
        <>
            <HeaderBottom />
            <div>
                <section className="services-area vh-100">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-8 col-md-12">
                                {/* <h3 className="text-center">Add Work Section</h3>
                                <form className="contact-form" onSubmit={handleWorkSection}>
                                    <div className="row">
                                        <div className="col-lg-12">
                                            <div className="form-group">
                                                <input type="text" className="form-control" name="stepNumber" placeholder="Step Number" required />
                                            </div>
                                        </div>
                                        <div className="col-lg-12">
                                            <div className="form-group">
                                                <input type="text" className="form-control" name="stepTitle" placeholder="Step Title" required />
                                            </div>
                                        </div>
                                        <div className="col-lg-12">
                                            <div className="form-group">
                                                <input type="text" className="form-control" name="stepDetails" placeholder="Step Details" required />
                                            </div>
                                        </div>
                                        <div className="text-center">
                                            <button className="theme-btn btn-one mt-3">Add Work Step</button>
                                        </div>
                                    </div>
                                </form> */}
                            </div>
                        </div>

                        <h3 className="text-center mt-5 mb-3">Your Work Step List</h3>
                        <div className="row justify-content-center">
                            {
                                stepwork.map((work, index) => (
                                    <div className="col-lg-4 col-md-6 mb-4" key={work._id}>
                                        <div className="card h-100 text-center">
                                            <div className="card-body">
                                                <h5 className="card-title">{work.stepNumberReal}: {work.stepTitle}</h5>
                                                <p className="card-text">{work.stepDetailsReal}</p>
                                            </div>
                                            <div className="card-footer">
                                                <Link to={`/edit-work-real/${work._id}`} className="theme-btn btn-one">Edit Now</Link>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            }
                        </div>
                    </div>
                </section>
            </div>
        </>
    );
};

export default WorkStepReal;
